import { PageContext } from "pages/[[...slug]]";
import { useContext } from "react";

import * as gtag from "@/lib/gtag";
import { Slot } from "utils/create-slots";

import { Icon } from "@/components/Icon";
import Accordion from "../components/Accordion";
import FooterMeta from "../FooterMeta";
import FooterItem from "../components/FooterItem";

const COL_POSITIONS = ["left", "center", "right"];

const FooterDefault = ({ items, service, meta, config }) => {
  return (
    <footer>
      <FooterLinkList items={items} />
      <FooterRowTop items={service} />
      <FooterRowBottom config={config} />

      <FooterMeta items={meta} config={config} />
    </footer>
  );
};

export default FooterDefault;

const FooterLinkList = ({ items }) => {
  const { config } = useContext(PageContext);
  if (Object.keys(items).length === 0) return null;
  const columns: any[] = Object.values(items);

  return (
    <div className="w-full bg-blue-light lg:!py-10  pb-2 !pt-8">
      <div className={`w-full container xl:grid xl:grid-cols-2 lg:gap-x-15`}>
        {columns.map((column: any[], index) => {
          return (
            <div className="  mb-5 last:mb-0" key={`columns-${index}`}>
              <h3>
                <p className="text-base text-white xl:text-2xl mb-5 xl:mb-7">
                  {config?.footer?.nav?.col[COL_POSITIONS[index]]?.headline}
                </p>
              </h3>

              <div className="mb-8 xl:mb-0 ">
                <ul
                  className={"grid grid-cols-2 lg:gap-x-15"}
                  data-orientation="horizontal"
                  dir="ltr"
                >
                  {column.map(({ title, link, target }) => (
                    <li
                      key={`${link}-${title}`}
                      className="mr-4 lg:mb-5 "
                      onClick={() => {
                        gtag.event({
                          event: "itemClick",
                          itemClick: "footer",
                          firstLevel: title || "firstLevel",
                        });
                      }}
                    >
                      <a
                        href={link}
                        target={target}
                        className="text-white text-sm pt-[9px] pb-[9px] lg:pt-0 lg:pb-3 hover:underline lg:hover:no-underline lg:border-b-[1px] lg:border-transparent lg:hover:border-white max-md:block max-md:w-full"
                      >
                        {title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const FooterRowTop = ({ items }) => {
  if (Object.keys(items).length === 0) return null;

  return (
    <div className="w-full bg-gray-100  xl:py-10 pt-6 lg:pb-2 pb-4 ">
      <div className="container">
        <Accordion className=" !w-full border-b-2 xl:border-transparent border-gray-300 ">
          <Accordion.Item value={1} key={1}>
            <Slot name="title">
              <Accordion.Trigger>
                {" "}
                <div className="xl:mb-8 xl:mt-0 my-6 items-center flex lg:text-4xl text-3xl">
                  <Icon
                    type={"info"}
                    className="w-8 h-8 inline text-orange-medium mr-4"
                  />
                  Hilfe + Kontakt
                </div>
              </Accordion.Trigger>
            </Slot>
            <Slot name="content">
              <Accordion.Content>
                <div className="!w-full grid xl:!grid-cols-4  lg:grid-cols-2 grid-cols-1  lg:gap-y-14 lg:gap-x-[92px]  gap-7 lg:pb-0 !pb-8 xl:mt-0 mt-4">
                  {items.map((item) => (
                    <FooterItem
                      textColor="blue-dark"
                      content={item}
                      key={item.title}
                    />
                  ))}
                </div>
              </Accordion.Content>
            </Slot>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
};
const FooterRowBottom = ({ config }) => {
  const contentCols = config?.footer?.rows?.content;
  if (!contentCols) return null;
  const { left, right } = JSON.parse(contentCols);

  return (
    <div className="w-full xl:bg-blue-dark bg-gray-100  xl:py-10 pt-0 pb-6">
      <div className="container">
        <div className=" grid xl:grid-cols-2 grid-cols-1">
          <Accordion className=" !w-full border-b-2 xl:border-transparent border-gray-300 [&>div>h3>button>svg]:-mt-5 [&>div>h3>button>svg]:lg:mt-0">
            <Accordion.Item value={1} key={1}>
              <Slot name="title">
                <Accordion.Trigger>
                  <div className="xl:mb-8 xl:mt-0 mt-5 mb-7 items-center flex xl:text-white lg:text-4xl text-3xl">
                    <Icon
                      type={left?.icon}
                      className="w-8 h-8 inline text-orange-medium mr-4"
                    />
                    {left.headline}
                  </div>
                </Accordion.Trigger>
              </Slot>
              <Slot name="content">
                <Accordion.Content>
                  <div className="!w-full grid xl:!grid-cols-2  lg:grid-cols-2 grid-cols-1  xl:gap-10 lg:gap-10 gap-7 lg:pb-0 !pb-8 xl:mt-0 mt-4">
                    {left.items.map((item, index) => (
                      <FooterItem
                        textColor="white"
                        content={item}
                        key={item.title}
                        index={index}
                      />
                    ))}
                  </div>
                </Accordion.Content>
              </Slot>
            </Accordion.Item>
          </Accordion>
          <Accordion className=" !w-full xl:ml-10">
            <Accordion.Item value={1} key={1}>
              <Slot name="title">
                <Accordion.Trigger>
                  <div className="xl:mb-8 xl:mt-0 my-6 items-center flex xl:text-white lg:text-4xl text-3xl">
                    <Icon
                      type={right?.icon}
                      className="w-8 h-8 inline text-orange-medium mr-4"
                    />
                    {right.headline}
                  </div>
                </Accordion.Trigger>
              </Slot>
              <Slot name="content">
                <Accordion.Content>
                  <div className="!w-full grid xl:!grid-cols-2  lg:grid-cols-2 grid-cols-1  xl:gap-10 lg:gap-10 gap-7 lg:pb-0 !pb-8 xl:mt-0 mt-4">
                    {right.items.map((item, index) => (
                      <FooterItem
                        textColor="white"
                        content={item}
                        key={item.title}
                        index={index}
                      />
                    ))}
                  </div>
                </Accordion.Content>
              </Slot>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
};
